import { useState } from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [newsletterMsg, setNewsletterMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setNewsletterMsg("");

    try {
      const res = await fetch(
        "https://hondaapi.clientcoding.com/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, email }),
        }
      );

      if (res.ok) {
        setNewsletterMsg("✅ Subscribed successfully!");
        setName("");
        setEmail("");
      } else {
        const errorData = await res.json();
        setNewsletterMsg("❌ " + (errorData?.message || "Subscription failed"));
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setNewsletterMsg("❌ Unexpected error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  let publicUrl = process.env.PUBLIC_URL + "/";
  return (
    <div className="col-lg-3 pd-top-50 go-top">
      <div className="category-sitebar">
        <div className="widget widget-category">
          <h6 className="widget-title">Category</h6>
          <div className="row custom-gutters-14">
            <div className="col-sm-6">
              <div className="single-category-inner">
                <img
                  src={publicUrl + "assets/img/news.jpg"}
                  alt="img"
                  height={75}
                />
                <Link className="tag-base tag-blue" to="/category/न्यूज़">
                  न्यूज़
                </Link>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="single-category-inner">
                <img
                  src={publicUrl + "assets/img/manoranjan.jpeg"}
                  alt="img"
                  height={75}
                />
                <Link className="tag-base tag-blue" to="/category/मनोरंजन">
                  मनोरंजन
                </Link>
              </div>
            </div>
            
           
            <div className="col-sm-6">
              <div className="single-category-inner">
                <img
                  src={publicUrl + "assets/img/health.webp"}
                  alt="img"
                  height={75}
                />
                <Link className="tag-base tag-blue" to="/category/हेल्थ">
                  हेल्थ
                </Link>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="single-category-inner">
                <img
                  src={publicUrl + "assets/img/trending.webp"}
                  alt="img"
                  height={75}
                />
                <Link className="tag-base tag-blue" to="/category/web-stories">
                  वेब स्टोरी
                </Link>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="single-category-inner">
                <img
                  src={publicUrl + "assets/img/dharam.avif"}
                  alt="img"
                  height={75}
                />
                <Link className="tag-base tag-blue" to="/category/धर्म">
                  धर्म
                </Link>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="single-category-inner">
                <img
                  src={publicUrl + "assets/img/business.jpg"}
                  alt="img"
                  height={75}
                />
                <Link className="tag-base tag-blue" to="/category/बिजनेस">
                  बिजनेस
                </Link>
              </div>
            </div>
            {/* <div className="col-12">
                            <div className="add">
                              <img
                                className="w-100"
                                src={publicUrl + "assets/img/add/3.png"}
                                alt="img"
                              />
                            </div>
                          </div> */}
          </div>
        </div>
        {/* <div className="widget widget-add">
              <div className="add">
                <img className="w-100" src={publicUrl+"assets/img/add/3.png"} alt="img" />
              </div>
            </div> */}
        <div className="widget widget-social">
          <h6 className="widget-title">Join to Us</h6>
          <ul className="social-area social-area-2">
            <li>
              <a
                className="facebook-icon"
                href="https://www.facebook.com/WeRNews/"
              >
                <i className="fa fa-facebook" />
              </a>
            </li>
            <li>
              <a className="twitter-icon" href="https://x.com/WeRNewsLive">
                <i className="fa-brands fa-x-twitter" />
              </a>
            </li>
            <li>
              <a
                className="youtube-icon"
                href="https://www.youtube.com/@WeRNewsLive"
              >
                <i className="fa fa-youtube-play" />
              </a>
            </li>
            <li>
              <a
                className="instagram-icon"
                href="https://www.instagram.com/wernewslive/"
              >
                <i className="fa fa-instagram" />
              </a>
            </li>
          </ul>
        </div>
        {/* <div className="widget">
              <h6 className="widget-title">Category</h6>
              <div className="post-slider owl-carousel">
                <div className="item">
                  <div className="trending-post">
                    <div className="single-post-wrap style-overlay">
                      <div className="thumb">
                        <img src={publicUrl+"assets/img/post/5.png"} alt="img" />
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <p><i className="fa fa-clock-o" />December 26, 2018</p>
                        </div>
                        <h6 className="title"><Link to="/news-details">The FAA will test drone </Link></h6>
                      </div>
                    </div>
                    <div className="single-post-wrap style-overlay">
                      <div className="thumb">
                        <img src={publicUrl+"assets/img/post/6.png"} alt="img" />
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <p><i className="fa fa-clock-o" />December 26, 2018</p>
                        </div>
                        <h6 className="title"><Link to="/news-details">Flight schedule and quarantine</Link></h6>
                      </div>
                    </div>
                    <div className="single-post-wrap style-overlay mb-0">
                      <div className="thumb">
                        <img src={publicUrl+"assets/img/post/7.png"} alt="img" />
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <p><i className="fa fa-clock-o" />December 26, 2018</p>
                        </div>
                        <h6 className="title"><Link to="/news-details">Indore bags cleanest city</Link></h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="trending-post">
                    <div className="single-post-wrap style-overlay">
                      <div className="thumb">
                        <img src={publicUrl+"assets/img/post/5.png"} alt="img" />
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <p><i className="fa fa-clock-o" />December 26, 2018</p>
                        </div>
                        <h6 className="title"><Link to="/news-details">The FAA will test drone </Link></h6>
                      </div>
                    </div>
                    <div className="single-post-wrap style-overlay">
                      <div className="thumb">
                        <img src={publicUrl+"assets/img/post/6.png"} alt="img" />
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <p><i className="fa fa-clock-o" />December 26, 2018</p>
                        </div>
                        <h6 className="title"><Link to="/news-details">Flight schedule and quarantine</Link></h6>
                      </div>
                    </div>
                    <div className="single-post-wrap style-overlay mb-0">
                      <div className="thumb">
                        <img src={publicUrl+"assets/img/post/7.png"} alt="img" />
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <p><i className="fa fa-clock-o" />December 26, 2018</p>
                        </div>
                        <h6 className="title"><Link to="/news-details">Indore bags cleanest city</Link></h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
        {/* <div className="widget">
              <div className="nxp-tab-inner nxp-tab-post-two mb-4">
                <ul className="nav nav-tabs" id="nx1" role="tablist">
                  <li className="nav-item" role="presentation">
                    <a className="nav-link active" id="nx1-tab-1" data-toggle="pill" href="#nx1-tabs-1" role="tab" aria-selected="true">
                      Recent
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a className="nav-link" id="nx1-tab-2" data-toggle="pill" href="#nx1-tabs-2" role="tab" aria-selected="false">
                      Populer        
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a className="nav-link" id="nx1-tab-3" data-toggle="pill" href="#nx1-tabs-3" role="tab" aria-selected="false">
                      Comment        
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="nx1-content">
                <div className="tab-pane fade show active" id="nx1-tabs-1" role="tabpanel">
                  <div className="single-post-list-wrap">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/1.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Himachal Pradesh rules in order to allow tourists </Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-post-list-wrap">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/2.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Online registration, booking for Vaishno Devi </Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-post-list-wrap mb-0">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/3.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Detecting technologies in airports this year</Link></h6>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
                <div className="tab-pane fade" id="nx1-tabs-2" role="tabpanel">
                  <div className="single-post-list-wrap">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/2.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Online registration, booking for Vaishno Devi </Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-post-list-wrap">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/3.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Detecting technologies in airports this year</Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-post-list-wrap mb-0">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/3.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Detecting technologies in airports this year</Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>            
                </div>
                <div className="tab-pane fade" id="nx1-tabs-3" role="tabpanel">
                  <div className="single-post-list-wrap">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/2.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Online registration, booking for Vaishno Devi </Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-post-list-wrap">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/2.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Online registration, booking for Vaishno Devi </Link></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-post-list-wrap mb-0">
                    <div className="media">
                      <div className="media-left">
                        <img src={publicUrl+"assets/img/post/list/3.png"} alt="img" />
                      </div>
                      <div className="media-body">
                        <div className="details">
                          <div className="post-meta-single">
                            <ul>
                              <li><i className="fa fa-clock-o" />08.22.2020</li>
                            </ul>
                          </div>
                          <h6 className="title"><Link to="/news-details">Detecting technologies in airports this year</Link></h6>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
            </div> */}
        <div className="widget">
          <form
            className="single-newsletter-inner bg-blue text-center"
            onSubmit={handleNewsletterSubmit}
          >
            <h5>Newsletter</h5>
            <p>Your daily dose of news — subscribe now</p>

            <div className="single-input-inner mb-2">
              <input
                type="text"
                placeholder="Enter Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="single-input-inner mb-3">
              <input
                type="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-white w-100"
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Subscribe Now"}
            </button>

            {newsletterMsg && (
              <p className="mt-3 text-white">{newsletterMsg}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
